var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.failure || _vm.success)?_c('p',{staticClass:"field-label is-normal help",class:{
    'has-text-primary': !!_vm.success,
    'has-text-danger': !!_vm.failure
  }},[_vm._v(" "+_vm._s(_vm.failure || _vm.success)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }